module.exports = __webpack_public_path__ + "img/flit2go-logo-circulo.d3351579.png";